/**
 * @fileoverview 프로젝트 업로드 페이지 - FSD 리팩토링 완료
 * 
 * 🎯 FSD 아키텍처 마이그레이션 완료!
 * 717라인 대형 모놀리식 컴포넌트 → 5개 FSD 패키지로 완전 분할
 * 
 * 📦 분할된 패키지들:
 * - packages/shared/project-upload-types: 모든 타입 정의
 * - packages/shared/project-upload-constants: 상수 및 메시지 정의  
 * - packages/shared/project-upload-styles: 18개 styled-components
 * - packages/shared/project-upload-utils: ZIP 처리 및 파일 유틸리티
 * - packages/features/project-upload: 메인 비즈니스 로직 및 컴포넌트
 * 
 * ✅ 이제 이 파일은 단순한 re-export 래퍼 역할만 수행합니다.
 */

// FSD Features Layer에서 완전히 리팩토링된 컴포넌트 import
import { ProjectUploadPage } from '@edusense/features-project-upload';

// Default export for backward compatibility
export default ProjectUploadPage;

// Named exports for new usage pattern
export { 
  ProjectUploadPage,
  useProjectUpload,
  type ProjectUploadPageProps,
  type UseProjectUploadProps,
  type UseProjectUploadReturn,
} from '@edusense/features-project-upload';